if (!customElements.get('card-upsell')) {
  customElements.define(
    'card-upsell',
    class CardUpsell extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderComponent = this.closest('.product-upsell__slider');
        this.jsonData = this.querySelector('[type="application/json"]');
        this.jsonDataParsed = JSON.parse(this.jsonData.textContent);
        this.optionsWrapper = this.querySelector('.upsell-quick-add__variant-selection');
        this.options = this.querySelectorAll('.upsell-quick-add__variant-option:not(.upsell-quick-add__variant-option--unavailable)');
        this.selectedOption = this.querySelector('.upsell-quick-add__variant-option--active');
        this.selectedVariant = this.getVariantById(this.selectedOption.dataset.variantId);

        this.optionsWrapper.addEventListener('click', (e) => e.stopPropagation());
        this.options.forEach((opt) => opt.addEventListener('click', this.onOptionClick.bind(this, opt)));

        this.apolloSection = document.querySelector(`#Apollo-${this.dataset.sectionId}`);
        this.hasApolloUpsell = !!this.apolloSection?.getSelectedVariantId();
      }

      updateOptions(html) {
        const newCard = html.querySelector(`.upsell-card-wrapper[data-section-id="${this.dataset.sectionId}"][data-product-id="${this.dataset.productId}"]`)

        const currentOptions = Array.from(this.querySelectorAll('.upsell-quick-add__variant-option'));
        const newOptions = Array.from(newCard.querySelectorAll('.upsell-quick-add__variant-option'));

        for (let i = 0; i < newOptions.length; i++) {
          const currentOption = currentOptions[i];
          const newOption = newOptions[i];

          currentOption.dataset.compareAtPrice = newOption.dataset.compareAtPrice;
          currentOption.dataset.compareAtPriceApolloBox = newOption.dataset.compareAtPriceApolloBox;
          currentOption.dataset.price = newOption.dataset.price;
          currentOption.dataset.priceApolloBox = newOption.dataset.priceApolloBox;
        }
      }

      updateApolloBox() {
        this.hasApolloUpsell = !!this.apolloSection?.getSelectedVariantId();
      }

      setOptionChangeCallback(callback) {
        this.optChangeCallback = callback;
      }

      onOptionClick(opt) {
        if (this.sliderComponent.classList.contains('slider-component--dragging')) return;

        this.options.forEach((opt) => opt.classList.remove('upsell-quick-add__variant-option--active'));
        opt.classList.add('upsell-quick-add__variant-option--active');
        this.selectedOption = opt;
        this.selectedVariant = this.getVariantById(opt.dataset.variantId);
        this.optChangeCallback();
      }

      getSelectedVariant() {
        return this.selectedVariant ?? null;
      }

      getSelectedVariantId() {
        return this.selectedVariant?.id ?? null;
      }

      getCompareAtPrice() {
        return this.hasApolloUpsell ? this.selectedOption?.dataset.compareAtPriceApolloBox ?? null : this.selectedOption?.dataset.compareAtPrice ?? null;
      }

      getPrice() {
        return this.hasApolloUpsell ? this.selectedOption?.dataset.priceApolloBox ?? null : this.selectedOption?.dataset.price ?? null;
      }

      getVariantById(id) {
        const idInt = parseInt(id)
        return this.getVariantData().find((v) => v.id === idInt) ?? null;
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }
    }
  );
}
